import React from "react";
import { Link } from "react-router-dom";
import { FaRegBuilding } from "react-icons/fa";
import { RiLeafLine } from "react-icons/ri";

/** Border Gradient Values:
 * from-[#5F89E4]
 * via-[#b565fb]
 * to-[#e00087]
 */
export default function TradenameResultCard({ product, currentUri, lastItemRef, highlightCardBorder = false, fixedHeight = false, fixedWidth = false }) {
    return (
        <div
            ref={lastItemRef}
            className={`relative overflow-hidden ${highlightCardBorder ? 'border-gradient' : 'border border-white'} shadow-2xl shadow-light-gray/5 rounded-xl
            ${fixedHeight ? 'max-h-[250px] lg:max-h-[200px]' : ''}
            ${fixedWidth ? 'w-full mr-[16px]' : ''}
            `}
        >
            <div className="border-gradient-container">
                <div className="flex items-start justify-between p-4 border-b border-stroke max-md:flex-col max-md:gap-2 max-md:items-start max-md:justify-center">
                    <div>
                        <Link
                            to={`/tradenames/${product.uri}`}
                            className="font-medium text-14 text-secondary hover:text-primary"
                        >
                            {product.name}
                        </Link>
                        <div className="flex items-start mt-1 text-14 text-light-gray/60">
                            <FaRegBuilding className="mr-2 mt-[0.15rem] text-light-gray/40 min-w-[16px]" />
                            {product.manufacturers.map(m => m.name).join(", ")}
                        </div>
                    </div>
                    <div className="flex items-center gap-1 text-12 font-text text-emerald-600 min-w-[105px] mt-[0.25rem]">
                        <RiLeafLine className="size-3.5 opacity-50" />
                        {product.ingredients.length} ingredients
                    </div>
                </div>

                <div className="p-4">
                    <div className="mb-2 text-12 font-text text-secondary/80">Active Ingredients:</div>
                    <div className={`flex flex-wrap gap-1.5 ${fixedHeight ? 'overflow-hidden max-h-[60px]' : ''}`}>
                        {product.ingredients.map((ingredient) => {
                            const isHighlighted = ingredient.uri === currentUri;
                            return (
                                <Link
                                    key={ingredient.uri}
                                    to={`/ingredients/${ingredient.uri}`}
                                    className={`
                                        px-2.5 py-1 text-12 font-text rounded-full h-fit
                                        ${isHighlighted
                                            ? 'bg-emerald-600/10 border border-emerald-600/30 text-emerald-600'
                                            : 'bg-secondary/5 hover:bg-emerald-600/5 text-secondary/80 hover:text-emerald-600'}
                                    `}
                                >
                                    {ingredient.name}
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
